<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>生产管理</el-breadcrumb-item>
      <el-breadcrumb-item>不良品库存管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.bomsn" @keyup.enter.native="clicksearch" placeholder="请输入材料编号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
          <div>入库总数量:{{Numruku}}</div>
          <div>出库总数量:{{Numchuku}}</div>
          <div>库总总数量:{{Numkucun}}</div>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Bomsn" label="材料编号" min-width="10%"></el-table-column>
          <el-table-column prop="Productname" label="材料名称" min-width="10%"></el-table-column>
          <el-table-column prop="Numruku" label="入库/出库" min-width="10%">
            <template slot-scope="scope">
              <span v-if="scope.row.Operationtype == 1" style="color: #67c23a;font-weight: 700;">入库</span>
              <span v-if="scope.row.Operationtype == 6" style="color: #409eff;font-weight: 700;">出库</span>
            </template>
          </el-table-column>
          <el-table-column prop="Operationnum" label="数量" min-width="10%"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 入库 start -->
      <el-tab-pane label="入库" name="second">
        <el-form :model="addForm" ref="addFormRef" label-width="70px">
          <el-form-item label="材料编号" class="addAdminForm">
            <el-input v-model="addForm.bomsn" placeholder="请输入材料编号"></el-input>
            <el-button type="success" plain @click="apiCheckProjectbom">校验</el-button>
            <li>项目名称：{{addForm.parentname}}</li>
            <li>材料名称：{{addForm.name}}</li>
          </el-form-item>
          <el-form-item label="数量" class="addAdminForm">
            <el-input v-model="addForm.operationnum" placeholder="请输入数量"></el-input>
          </el-form-item>
          <el-form-item label="备注" class="addAdminForm">
            <el-input v-model="addForm.beizhu" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="apiAddmadedefectiveproductkucun(1)">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 入库 end -->

      <!-- 出库 start -->
      <el-tab-pane label="出库" name="three">
        <el-form :model="addForm" ref="addFormRef" label-width="70px">
          <el-form-item label="材料编号" class="addAdminForm">
            <el-input v-model="addForm.bomsn" placeholder="请输入材料编号"></el-input>
            <el-button type="success" plain @click="apiCheckProjectbom">校验</el-button>
            <li>项目名称：{{addForm.parentname}}</li>
            <li>材料名称：{{addForm.name}}</li>
          </el-form-item>
          <el-form-item label="数量" class="addAdminForm">
            <el-input v-model="addForm.operationnum" placeholder="请输入数量"></el-input>
          </el-form-item>
          <el-form-item label="备注" class="addAdminForm">
            <el-input v-model="addForm.beizhu" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="apiAddmadedefectiveproductkucun(6)">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 出库 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyDefectiveProductKucun',
  data () {
    return {
      activeName: 'first',
      addForm: {
        bomsn: '',
        operationnum: '',
        operationtype: '',
        beizhu: '',
        parentname: '',
        name: ''
      },
      keywords: {
        bomsn: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      Numruku: 0,
      Numchuku: 0,
      Numkucun: 0
    }
  },
  mounted () {
    this.apiGetmadedefectiveproductkucunnum()
    this.apiGetmadedefectiveproductkucunlist()
  },
  methods: {
    clickreturn (val) {
      this.activeName = 'first'
      this.apiGetmadedefectiveproductkucunnum()
      this.apiGetmadedefectiveproductkucunlist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetmadedefectiveproductkucunnum()
      this.apiGetmadedefectiveproductkucunlist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetmadedefectiveproductkucunlist()
    },
    apiGetmadedefectiveproductkucunnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.keywords.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getmadedefectiveproductkucunnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetmadedefectiveproductkucunlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        bomsn: that.keywords.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getmadedefectiveproductkucunlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.Numruku = response.data.Numruku
            that.Numchuku = response.data.Numchuku
            that.Numkucun = response.data.Numkucun
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiCheckProjectbom: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.addForm.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckProjectbom, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.addForm.bomsn = response.data.Bomsn
            that.addForm.parentname = response.data.Parentname
            that.addForm.name = response.data.Name
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddmadedefectiveproductkucun: function (operationtype) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.addForm.bomsn,
        operationnum: that.addForm.operationnum,
        operationtype: operationtype,
        beizhu: that.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addmadedefectiveproductkucun, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.addForm.bomsn = ''
            that.addForm.operationnum = ''
            that.addForm.operationtype = ''
            that.addForm.beizhu = ''
            that.addForm.parentname = ''
            that.addForm.name = ''
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.mytitle{
  color: #000000;
  font-weight:bold;
}

</style>
